import router from './router'
import UserMessages from './localization'

export default {
  router,
  localization: UserMessages,
}
